import { createFileRoute } from "@tanstack/react-router";
import Trial30Zile from "@/pages/produs/Trial30Zile";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/trial-30-zile/")({
  head: () => routeHead("/trial-30-zile/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Trial30Zile />
  );
}
